import { render } from "./App.vue?vue&type=template&id=136c5f2c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=136c5f2c&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/cn-chatbot-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__